<template>
    <div>
        <!--TODO: enable this for all admins-->
        <!--<div v-if="!$store.state.currentAccount.isEnterpriseAdminOrg && (account.isSuperAdmin || isAdminOrgAccessType(this.$store.state.currentAccount.selectedOrganizationAccessTypeId))">-->
        <div class="tool-section" v-if="!$store.state.currentAccount.isEnterpriseAdminOrg && isAdminOrgAccessType($store.state.currentAccount.selectedOrganizationAccessTypeId)">
            <h3>
                Possible Duplicate Profiles
            </h3>
            <p>Gets a report of any profile pairs that share at least 2 of the following: First Name, Last Name, Date of Birth.<br />
               Please note that not all results in this table should be merged - for instance twins will likely show up but should not be merged.</p>
            <app-form
                    style="width: 350px"
                    submit-button-title="Get Report"
                    :saving="isGettingDuplicateReport"
                    @submit="getDuplicateReport"
            >
            </app-form>
            <p v-if="possibleDuplicateProfiles && possibleDuplicateProfiles.length == 0">No possible duplicates found</p>
            <div v-if="possibleDuplicateProfiles && possibleDuplicateProfiles.length > 0">
                <table>
                    <thead>
                        <tr>
                            <td>
                                Profile Id
                            </td>
                            <td v-if="!viewingAsSuper">
                                First Name
                            </td>
                            <td v-if="!viewingAsSuper">
                                Last Name
                            </td>
                            <td v-if="!viewingAsSuper">
                                Date of Birth
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(pair, i) in possibleDuplicateProfiles">
                            <tr :class="(i % 2) ? 'white-bg' : 'gray-bg'">
                                <td>
                                    {{pair.profile1.id}}
                                </td>
                                <td v-if="!viewingAsSuper">
                                    {{pair.profile1.firstName}}
                                </td>
                                <td v-if="!viewingAsSuper">
                                    {{pair.profile1.lastName}}
                                </td>
                                <td v-if="!viewingAsSuper">
                                    {{pair.profile1.birthDate}}
                                </td>
                                <td rowspan="2">
                                    <app-btn @click="startMergeFromReport(pair.profile1, pair.profile2)">
                                        Merge
                                    </app-btn>
                                </td>
                            </tr>
                            <tr :class="(i % 2) ? 'white-bg' : 'gray-bg'">
                                <td>
                                    {{pair.profile2.id}}
                                </td>
                                <td v-if="!viewingAsSuper">
                                    {{pair.profile2.firstName}}
                                </td>
                                <td v-if="!viewingAsSuper">
                                    {{pair.profile2.lastName}}
                                </td>
                                <td v-if="!viewingAsSuper">
                                    {{pair.profile2.birthDate}}
                                </td>
                                <td></td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="tool-section" v-if="!$store.state.currentAccount.isEnterpriseAdminOrg">
            <h3>
                Merge Profiles
            </h3>
            <app-form
                style="width: 350px"
                submit-button-title="Merge Profiles"
                :saving="isMergingProfiles"
                @submit="startMerge"
            >
                <div class="mt-2" >
                    <app-text-field
                        label="Profile ID to Keep"
                        row
                        v-model="mergeProfilesData.profileToKeepId"
                        white-background
                        rules="required|positive"
                    />
                    <br />
                    <app-text-field
                        label="Profile ID to Lose"
                        row
                        v-model="mergeProfilesData.profileToLoseId"
                        white-background
                        rules="required|positive"
                        class="mt-2"
                    />
                </div>
            </app-form>
            <app-confirm-dialog :open="mergeProfilesData.profileToKeepName && mergeProfilesData.profileToLoseName"
                                title="Confirm Merge"
                                @close="cancelMerge"
                                @confirm="confirmMerge"
                                :loading="isMergingProfiles">
                <div>
                    <p>Are you sure you want to merge the following profiles?</p>
                    <div style="float: left; width: 90%">
                        Profile to Keep: {{mergeProfilesData.profileToKeepName}}<br/>
                        Profile to Lose: {{mergeProfilesData.profileToLoseName}}
                    </div>
                    <div style="float: right; width: 10%">
                        <app-fab-btn icon-name="icon-swap" @click="swapMerge"></app-fab-btn>
                    </div>
                </div>
            </app-confirm-dialog>
        </div>
        <!--hide for now
        <div class="tool-section" v-if="false && account.isSuperAdmin && !$store.state.currentAccount.isEnterpriseAdminOrg">
            <h3>
                Merge Profiles (Bulk)
            </h3>
            <app-form
                    style="width: 350px"
                    submit-button-title="Merge Profiles"
                    :saving="isBulkMergingProfiles"
                    @submit="mergeProfileBulk"
            >
                <div class="mt-2" >
                    <AppTextArea
                            v-model="bulkMergeString"
                            label="Bulk Merge - Input Profile Ids as a CSV-like format, with one pair on each line"
                            error-label="Test Note"
                            :rows="20"
                    />
                </div>
            </app-form>
            <app-confirm-dialog :open="mergeProfilesData.profileToKeepName && mergeProfilesData.profileToLoseName"
                                title="Confirm Merge"
                                @close="cancelMerge"
                                @confirm="confirmMerge"
                                :loading="isBulkMergingProfiles">
                <div>
                    <p>Are you sure you want to merge the following profiles?</p>
                    <p>
                        Profile to Keep: {{mergeProfilesData.profileToKeepName}}<br/>
                        Profile to Lose: {{mergeProfilesData.profileToLoseName}}
                    </p>
                </div>
            </app-confirm-dialog>
        </div>-->
        <div class="tool-section" v-if="$store.state.currentAccount.isEnterpriseAdminOrg && isAdminOrgAccessType($store.state.currentAccount.selectedOrganizationAccessTypeId)">
            <h3>
                Transfer Profile (Enterprise)
            </h3>
            <app-form
                    style="width: 350px"
                    submit-button-title="Transfer Profile"
                    :saving="isTransferringProfiles"
                    @submit="startTransferProfile"
            >
                <div class="mt-2" >
                    <app-text-field
                            label="Profile ID to Transfer"
                            row
                            v-model="transferProfileData.profileId"
                            type="number"
                            white-background
                            rules="required|positive"
                    />
                    <br />
                    <AppSelect label="New Organization"
                               row
                               v-model="transferProfileData.organizationId"
                               :items="organizationList"
                               item-text="label"
                               item-value="id"
                    />
                </div>
            </app-form>
            <app-confirm-dialog :open="transferProfileData.profileName"
                                title="Confirm Transfer"
                                @close="cancelTransferProfile"
                                @confirm="confirmTransferProfile"
                                :loading="isTransferringProfiles">
                <div>
                    <p>Are you sure you want to transfer the following profile?</p>
                    <p>
                        Profile: {{transferProfileData.profileName}}<br/>
                        New Organization: {{transferProfileData.organizationName}}
                    </p>
                </div>
            </app-confirm-dialog>
        </div>
        <div class="tool-section" v-if="account.isSuperAdmin && !$store.state.currentAccount.isEnterpriseAdminOrg">
            <h3>
                Transfer Profile (Super Admin)
            </h3>
            <app-form
                    style="width: 350px"
                    submit-button-title="Transfer Profile"
                    :saving="isTransferringProfiles"
                    @submit="startTransferProfile"
            >
                <div class="mt-2" >
                    <app-text-field
                            label="Profile ID to Transfer"
                            row
                            v-model="transferProfileData.profileId"
                            type="number"
                            white-background
                            rules="required|positive"
                    />
                    <br />
                    <app-text-field
                               label="New Organization Id"
                               row
                               v-model="transferProfileData.organizationId"
                               type="number"
                               white-background
                               rules="required|positive"
                    />
                </div>
            </app-form>
            <app-confirm-dialog :open="transferProfileData.profileName"
                                title="Confirm Transfer"
                                @close="cancelTransferProfile"
                                @confirm="confirmTransferProfile"
                                :loading="isTransferringProfiles">
                <div>
                    <p>Are you sure you want to transfer the following profile?</p>
                    <p>
                        Profile: {{transferProfileData.profileName}}<br/>
                        New Organization: {{transferProfileData.organizationName}}
                    </p>
                </div>
            </app-confirm-dialog>
        </div>
        <div class="tool-section" v-if="account.isSuperAdmin">
            <h3>
                Transfer Test
            </h3>
            <app-form
                    style="width: 350px"
                    submit-button-title="Transfer Test"
                    :saving="isTransferringTest"
                    @submit="onTransferTest"
            >
                <div  class="mt-2" >
    
                    <app-text-field
                            label="Test ID"
                            row
                            v-model="transferTestData.profileTestId"
                            white-background
                            rules="required|positive"
                    />
                    <app-text-field
                            label="Current Profile ID"
                            row
                            v-model="transferTestData.currentProfileId"
                            white-background
                            rules="required|positive"
                            class="mt-2"
                    />
                    <app-text-field
                            label="New Profile ID"
                            row
                            v-model="transferTestData.newProfileId"
                            white-background
                            rules="required|positive"
                            class="mt-2"
                    />
                </div>
            </app-form>
        </div>
        <div class="tool-section" v-if="account.isSuperAdmin">
            <h3>
                Change Tests taken on Code (and Code) from Non-baseline to Baseline
            </h3>
            <app-form
                style="width: 350px"
                submit-button-title="Change Tests to Baseline"
                :saving="isChangingTestsToBaseline"
                @submit="onChangeTestsToBaseline"
            >
                <div class="mt-2" >
                    <app-text-field
                        label="Code"
                        row
                        v-model="changeTestsToBaselineData.code"
                        white-background
                        rules="required"
                    />
                    <app-text-field
                        label="Organization ID"
                        row
                        v-model="changeTestsToBaselineData.organizationId"
                        type="number"
                        white-background
                        rules="required|positive"
                        class="mt-2"
                    />
                </div>
            </app-form>

            <h3>
                Transfer Group of Profiles
            </h3>
            <app-form
                style="width: 350px"
                submit-button-title="Transfer Group of Profiles"
                :saving="isTransferringGroupOfProfiles"
                @submit="onTransferGroupOfProfiles"
            >
                <div style="display: flex; align-items: center">
                    <v-icon style="color: rgba(255,0,0,.5)" :size="16">mdi-alert</v-icon>
                    <span style="color: rgba(255,0,0,.5); font-weight: 800; margin-left: 5px">IMPORTANT NOTE: </span>
                </div>
                <div style="margin-bottom: 10px">
                    <strong>All profiles in specified group will be transferred to the new organization and will be DELETED from the current organization.</strong>
                </div>
                <div style="margin-bottom: 10px">
                    Put a 0 for "New Group Id" to duplicate the group in the new organization.
                </div>
                <div  class="mt-2" >

                    <app-text-field
                        label="Current Org Id"
                        row
                        v-model="transferGroupOfProfiles.fromOrgId"
                        white-background
                        rules="required|positive"
                    />
                    <app-text-field
                        label="New Org Id"
                        row
                        v-model="transferGroupOfProfiles.toOrgId"
                        white-background
                        rules="required|positive"
                        class="mt-2"
                    />
                    <app-text-field
                        label="Current Group Id"
                        row
                        v-model="transferGroupOfProfiles.fromGroupIds"
                        white-background
                        rules="required"
                        class="mt-2"
                    />
                    <app-text-field
                        label="New Group Id"
                        row
                        v-model="transferGroupOfProfiles.toGroupId"
                        white-background
                        rules="required|positive"
                        class="mt-2"
                    />
                </div>
            </app-form>
        </div>
    </div>
</template>

<script>
import {
    startMergeProfiles, confirmMergeProfiles, startTransferProfile, confirmTransferProfile,
    transferTest, transferGroupOfProfiles, getDuplicateReport, changeTestsToBaseline
} from "@/services/tools.service";
import {SET_SNACKBAR} from "@/store/mutation-types";
import {isAdminOrgAccessType} from "@/js/shared/helper";
import AppTextArea from "@/components/forms/AppTextArea.vue";

export default {
    name: "Tools",
    components: {AppTextArea},
    data() {
        return {
            possibleDuplicateProfiles: null,
            isGettingDuplicateReport: false,
            
            mergeProfilesData: {
                profileToKeepId: null,
                profileToKeepName: null,
                profileToLoseId: null,
                profileToLoseName: null,
            },
            isMergingProfiles: false,

            bulkMergeString:
`ProfileToKeepId,ProfileToLoseId
`,
            isBulkMergingProfiles: false,

            transferProfileData: {
                profileId: null,
                organizationId: null
            },
            isTransferringProfiles: false,
            
            transferTestData: {
                profileTestId: null,
                currentProfileId: null,
                newProfileId: null,
            },
            isTransferringTest: false,

            transferGroupOfProfiles: {
                fromOrgId: null,
                toOrgId: null,
                fromGroupIds: null,
                toGroupId: null,
            },
            isTransferringGroupOfProfiles: false,

            changeTestsToBaselineData: {
                code: null,
                organizationId: null,
            },
            isChangingTestsToBaseline: false
        }
    },
    props: {
        account: {}
    },
    computed: {
        viewingAsSuper() {
            let {viewingAsSuper} = this.$store.state.currentAccount;
            return viewingAsSuper;
        },
        organizationList() {
            return this.$store.state.currentAccount.availableOrganizations
                    .filter(x => !x.isDisabled && !x.isEnterpriseAdminOrg)
                    .map(x => ({label: x.name, id: x.id}));
        },
    },
    methods: {
        isAdminOrgAccessType,
        async getDuplicateReport(){
            this.isGettingDuplicateReport = true;
            
            let response = await getDuplicateReport();

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            }
            else{
                this.possibleDuplicateProfiles = response.profiles;
            }

            this.isGettingDuplicateReport = false
        },
        async startMerge() {
            this.isMergingProfiles = true
            let request = {...this.mergeProfilesData};

            let response = await startMergeProfiles(request);

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            }
            else{
                this.mergeProfilesData.profileToLoseName = response.profileToLoseName;
                this.mergeProfilesData.profileToKeepName = response.profileToKeepName;
            }

            this.isMergingProfiles = false
        },
        async startMergeFromReport(profile1, profile2) {
            
            if (profile1.id < profile2.id) {
                this.mergeProfilesData = {
                    profileToKeepId: profile1.id,
                    profileToKeepName: profile1.firstName + ' ' + profile1.lastName,
                    profileToLoseId: profile2.id,
                    profileToLoseName: profile2.firstName + ' ' + profile2.lastName,
                };
            }else{
                this.mergeProfilesData = {
                    profileToKeepId: profile2.id,
                    profileToKeepName: profile2.firstName + ' ' + profile2.lastName,
                    profileToLoseId: profile1.id,
                    profileToLoseName: profile1.firstName + ' ' + profile1.lastName,
                };
            }

            await this.startMerge();
        },
        async swapMerge() {

            const id = this.mergeProfilesData.profileToKeepId;
            const name = this.mergeProfilesData.profileToKeepName;
            this.mergeProfilesData.profileToKeepId = this.mergeProfilesData.profileToLoseId;
            this.mergeProfilesData.profileToKeepName = this.mergeProfilesData.profileToLoseName;
            this.mergeProfilesData.profileToLoseId = id;
            this.mergeProfilesData.profileToLoseName = name;
            
        },
        async confirmMerge() {
            let request = {...this.mergeProfilesData};

            let response = await confirmMergeProfiles(request);

            if (!response.isSuccess) {

                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            } else {
                this.$store.commit(SET_SNACKBAR, {
                    text: `Successfully merged profiles.`,
                    color: 'success',
                    open: true
                });

                this.mergeProfilesData.profileToKeepId = null
                this.mergeProfilesData.profileToKeepName = null
                
                this.mergeProfilesData.profileToLoseId = null
                this.mergeProfilesData.profileToLoseName = null
            }

            if (this.possibleDuplicateProfiles)
                this.getDuplicateReport();
                
            this.isMergingProfiles = false
        },
        async cancelMerge(){
            this.mergeProfilesData.profileToLoseName = null;
            this.mergeProfilesData.profileToKeepName = null;

            this.isMergingProfiles = false;
        },
        async mergeProfileBulk(){
            this.isBulkMergingProfiles = true;
            
            let errorMessage = "";
            let mergeRequests = [];
            let mergeLines = this.bulkMergeString.split("\n");
            for (let i = 0; i < mergeLines.length; i++)
            {
                if (!mergeLines[i] || mergeLines[i].startsWith("ProfileToKeepId,ProfileToLoseId"))
                    continue;
                
                let mergeRequest = {};
                try{
                    mergeRequest.profileToKeepId = Number(mergeLines[i].split(",")[0]);
                    mergeRequest.profileToLoseId = Number(mergeLines[i].split(",")[1]);
                    if (!mergeRequest.profileToKeepId){
                        errorMessage += "Invalid profile to keep on row " + (i+1)
                    }
                    if (!mergeRequest.profileToLoseId){
                        errorMessage += "Invalid profile to lose on row " + (i+1)
                    }
                    
                    mergeRequests.push(mergeRequest);
                }
                catch(error){
                    errorMessage += "Invalid format on row " + (i+1)
                }
            }
            
            if (errorMessage)
            {
                this.$store.commit(SET_SNACKBAR, {
                    text: errorMessage,
                    color: 'error',
                    open: true
                });
            }
            else
            {
                for (let i = 0; i < mergeRequests.length; i++)
                {
                    try
                    {
                        let request = {...mergeRequests[i]};

                        let response = await confirmMergeProfiles(request);
                        if (!response.isSuccess) {

                            this.$store.commit(SET_SNACKBAR, {
                                text: response.errors[0].message,
                                color: 'error',
                                open: true
                            });
                            return;
                        }
                    }
                    catch(error)
                    {
                        this.$store.commit(SET_SNACKBAR, {
                            text: "Failure to merge on row " + (i+1),
                            color: 'error',
                            open: true
                        });
                        this.isBulkMergingProfiles = false;
                        return;
                    }
                }
                
                this.$store.commit(SET_SNACKBAR, {
                    text: `Successfully merged profiles.`,
                    color: 'success',
                    open: true
                });
            }

            this.isBulkMergingProfiles = false;
        },
        async startTransferProfile() {
            this.isTransferringProfiles = true
            let request = {...this.transferProfileData};

            let response = await startTransferProfile(request);

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            }
            else{
                this.transferProfileData.profileName = response.profileName;
                this.transferProfileData.organizationName = response.organizationName;
            }

            this.isTransferringProfiles = false
        },
        async confirmTransferProfile() {
            let request = {...this.transferProfileData};

            let response = await confirmTransferProfile(request);

            if (!response.isSuccess) {

                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            } else {
                this.$store.commit(SET_SNACKBAR, {
                    text: `Successfully transferred profiles.`,
                    color: 'success',
                    open: true
                });

                this.transferProfileData.profileId = null
                this.transferProfileData.organizationId = null
                this.transferProfileData.profileName = null
            }

            this.isTransferringProfiles = false
        },
        async cancelTransferProfile(){
            this.transferProfileData.profileId = null
            this.transferProfileData.organizationId = null
            this.transferProfileData.profileName = null

            this.isTransferringProfiles = false
        },
        async onTransferTest() {

            this.isTransferringTest = true
            let request = {...this.transferTestData};
            let response = await transferTest(request);

            if (!response.isSuccess) {

                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            } else {
                this.$store.commit(SET_SNACKBAR, {
                    text: `Successfully transferred test.`,
                    color: 'success',
                    open: true
                });

                this.transferTestData.newProfileId = null
                this.transferTestData.currentProfileId = null
                this.transferTestData.profileTestId = null
            }

            this.isTransferringTest = false
        },
        async onTransferGroupOfProfiles() {
            
            let confirmation = confirm("Are you sure? All profiles in Group #" + this.transferGroupOfProfiles.fromGroupIds + 
                " will be transferred to Org #" + this.transferGroupOfProfiles.toOrgId + 
                ", and will be deleted from Org #" + this.transferGroupOfProfiles.fromOrgId);
            
            if (!confirmation)
                return;

            this.isTransferringGroupOfProfiles = true
            let request = {...this.transferGroupOfProfiles};
            let response = await transferGroupOfProfiles(request);

            if (!response.isSuccess) {

                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            } else {
                this.$store.commit(SET_SNACKBAR, {
                    text: `Successfully transferred group of profiles.`,
                    color: 'success',
                    open: true
                });

                this.transferGroupOfProfiles.fromOrgId = null
                this.transferGroupOfProfiles.toOrgId = null
                this.transferGroupOfProfiles.fromGroupIds = null
                this.transferGroupOfProfiles.toGroupId = null
            }

            this.isTransferringGroupOfProfiles = false
        },
        async onChangeTestsToBaseline() {
            this.isChangingTestsToBaseline = true
            let request = {...this.changeTestsToBaselineData};
            let response = await changeTestsToBaseline(request);

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
            } else {
                this.$store.commit(SET_SNACKBAR, {
                    text: `Successfully changed tests to baseline.`,
                    color: 'success',
                    open: true
                });

                this.changeTestsToBaselineData.code = null
                this.changeTestsToBaselineData.organizationId = null
            }

            this.isChangingTestsToBaseline = false
        }
        
    }
}
</script>

<style scoped>
.white-bg{
    border: 1px solid var(--main-border-color);
    background-color: white;
}
.gray-bg{
    border: 1px solid var(--main-border-color);
    background-color: whitesmoke;
}

.tool-section{
    padding-bottom: 20px;
}
</style>